import React from 'react';
import './GalleryCard.scss';

interface GalleryCardProps {
  heading?: string;
  categories?: string[];
  authorName?: string;
  authorTitle?: string;
  authorImage?: string;
}

const GalleryCard: React.FC<GalleryCardProps> = ({
  heading = 'Praktische Tipps zur Behandlung der leichten kognitiven Störung in der Praxis',
  categories = ['Category 1', '60 min', '2 CME Punkte'],
  authorName = 'Dr Angelika Thöne-Otto',
  authorTitle = 'Vorstand der Gesellschaft für Neuropädiatrie',
  authorImage = 'https://picsum.photos/seed/2/98/98',
}) => {
  return (
    <div className="gallery-card">
      <h2 className="gallery-card__heading">{heading}</h2>

      <div className="gallery-card__author-section">
        <img
          src={authorImage}
          alt={authorName ? `Porträt von ${authorName}` : 'Porträt des Autors'}
          className="gallery-card__author-image"
        />
        <div className="gallery-card__author-info">
          <p className="gallery-card__author-name">{authorName}</p>
        </div>
      </div>
    </div>
  );
};

export default GalleryCard;
